import Handlebars from 'handlebars/dist/handlebars.js'
import asyncHelpers from 'handlebars-async-helpers'

export const asyncHandlebars = asyncHelpers(Handlebars)
